import ButtonSimple from './ButtonSimple';

export { ButtonSimple };


// WEBPACK FOOTER //
// ./src/Components/Elements/Buttons/index.js